import { module } from 'angular';
import { ResetModel } from './model/reset';

export default module('app').service('Reset', ResetModel);
